import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20Korean%20webtoon%20manhwa%20illustration%20collage%20of%20colorful%20floating%20comic%20panels%20and%20brush%20strokes%20in%20warm%20amber%20orange%20and%20cream%20tones%2C%20paper%20texture%2C%20magazine%20editorial%20background%2C%20artistic%20and%20vibrant%2C%20dynamic%20depth%2C%20no%20text&width=1600&height=900&seq=hero-kr-2026&orientation=landscape"
          alt="韩国漫画大全 每日更新首屏背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-6 md:pb-24 md:pt-40">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur-sm">
          <i className="ri-refresh-line"></i>
          每日更新不停歇 · 连载进度同步
        </span>

        <h1 className="font-heading text-4xl leading-tight text-white md:text-6xl">
          韩国漫画大全
          <span className="mt-2 block text-2xl font-normal text-secondary-200 md:text-3xl">韩漫大全最新内容，每日同步收录</span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          最新上线韩漫新作第一时间收录，连载进度实时同步，本周更新一目了然。追更韩漫大全，就看这里。
        </p>

        {/* Search */}
        <form onSubmit={submit} className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full bg-white p-1.5 shadow-sm">
          <i className="ri-search-line pl-3 text-lg text-foreground-500"></i>
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索你想要的韩漫名称 / 分类"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            aria-label="搜索韩国漫画"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        {/* Category chips */}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {categories.slice(0, 8).map((c) => (
            <Link
              key={c.name}
              to={`/category?genre=${encodeURIComponent(c.name)}`}
              className="whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs text-white backdrop-blur-sm transition-colors hover:bg-primary-500/80"
            >
              {c.name}
            </Link>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { num: '2,800+', label: '收录韩漫作品' },
            { num: '1,200+', label: '连载中佳作' },
            { num: '每日', label: '更新不停歇' },
            { num: '99.9%', label: '进度同步率' },
          ].map((s) => (
            <div key={s.label} className="rounded-lg border border-white/15 bg-white/10 px-4 py-4 backdrop-blur-sm">
              <p className="font-heading text-2xl text-secondary-200 md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-white/75 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}